import React, { useState } from "react";
import "../../App.css";
import { useParams, useNavigate } from "react-router-dom";
import { signal } from "@preact/signals-react";
import { useSelector } from "react-redux";
import Appconfig from "../../config/config";

// Component Imports
import HorseRacingSchedule from "../../components/horseRacingSchedule";
import Cricket from "../../components/cricket";
import Tennis from "../../components/tennis";
import Soccer from "../../components/soccer";
import GreyhoundRacingSchedule from "../../components/greyhoundRacingSchedule";
import Politics from "../../components/politics";
import Lottery from "../../components/lottery";
import News from "../../components/news";
import Footer from "pages/footer";
import OpenBets from "components/openbets";

export const eventId = signal("");

function AllSportHighlights({ selectedSportId }) {
  const navigate = useNavigate();
  // 1. Get ID from URL parameters
  const { id: paramId } = useParams();

  // 2. Check if this is a direct page load (URL param exists, Prop does not)
  // If selectedSportId is passed, it means this component is embedded inside another page (tabs), so we hide sidebars.
  // If selectedSportId is undefined, we assume it's a direct browser open, so we SHOW sidebars.
  const isDirectPage = !selectedSportId;

  // 3. Determine the active ID
  const id = selectedSportId || paramId;

  // Redux Selectors
  const userInfo = useSelector((state) => state?.userInfo?.userdata);

  // Sidebar Menu State
  const [activeTab, setActiveTab] = useState("Sports");
  const menuItems = [
    { name: "Cricket", id: 4 },
    { name: "Soccer", id: 1 },
    { name: "Tennis", id: 2 },
  ];

  // Helper to get static banner based on Sport ID
  const getBannerImage = (sportId) => {
    // 
    if (sportId == 4) return "/images/kv_cricket.jpg"; // Replace with your actual path
    // 

// [Image of Soccer Field or Ball]

    if (sportId == 1) return "/images/kv_soccer.jpg";   // Replace with your actual path
    // 

// [Image of Tennis Court]

    if (sportId == 2) return "/images/kv_tennis.jpg";   // Replace with your actual path
    
    // Default/Fallback
    return "/other/slider.webp";
  };

  const handleSidebarClick = (item) => {
    setActiveTab(item.name);
    // Optional: Navigate to the clicked sport if you want the URL to change
    if(item.id) {
        navigate(`/allsport-highlight/${item.id}`);
    }
  };

  return (
    <>
      {/* =========================
          DESKTOP VIEW 
      ========================= */}
      <div className="hidden col-span-12 lg:flex justify-center my-[1px] w-full">
        
        {/* --- LEFT SIDEBAR (20%) - Only show if direct page --- */}
        {isDirectPage && (
          <div className="w-[18%] h-screen bg-white text-black flex flex-col shadow-lg mx-[5px] sticky top-0 overflow-y-auto">
            <div
              className={`py-[2px] px-[10px] text-[12px] font-bold border-b border-gray-300 bg-black text-white`}
            >
              Sports Menu
            </div>
            <ul className="flex flex-col">
              {menuItems.map((item) => (
                <li
                  key={item.name}
                  onClick={() => handleSidebarClick(item)}
                  className={`cursor-pointer border-b border-gray-200 transition-colors duration-200 py-[2px] px-[10px] text-[13px] font-medium flex justify-between items-center ${
                    Number(id) === item.id
                      ? "bg-[#000000] text-white"
                      : "hover:bg-gray-100 text-gray-800"
                  }`}
                >
                  {item.name}
                  <i className="fa fa-angle-right"></i>
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* --- MAIN CONTENT (Flexible Width) --- */}
        <div className={`${isDirectPage ? "w-[55%]" : "w-full"} flex flex-col`}>
          
          {/* News Ticker */}
          {userInfo && (
            <div className="w-full leading-[15px] bg-[linear-gradient(-180deg,#474747_0%,#070707_100%)] mb-2">
              <h4 className="z-10 text-[12px] font-bold relative bg-[linear-gradient(-180deg,_#274253_0%,_#0f191f_82%)] text-[#ffffff] pl-[9px] pr-[4px] py-[4px] inline-block">
                <i className="fa fa-microphone"></i>
                <span>&nbsp;News</span>
              </h4>
              <marquee
                direction="left"
                scrollamount="5"
                behavior="scroll"
                className="w-[90%] text-[#ffffff] inline-table font-bold text-[12px] leading-[21px]"
              >
                <News />
              </marquee>
            </div>
          )}

          {/* STATIC BANNER SECTION (No Carousel) */}
          <div className="w-full mb-2">
            <img
              style={{ height: "208px", width: "100%", objectFit: "cover" }}
              src={getBannerImage(id)}
              alt="Sport Banner"
              onError={(e) => { e.target.src = "/other/slider.webp"; }} // Fallback if image not found
            />
          </div>

          {/* Highlights Header */}
          <div
            className={`px-[10px] py-[5px] bg-[linear-gradient(180deg,_#ffcc2e_0%,_#ffbd14_100%)] mb-2 ${
              id == 66104 && "hidden"
            }`}
          >
            <h3 className="text-[0.9rem] text-black font-bold uppercase">Highlights</h3>
          </div>

          {/* Game Components */}
          <div className="w-full">
            {id == 4 && <Cricket />}
            {id == 2 && <Tennis />}
            {id == 1 && <Soccer />}
            {id == 7 && <HorseRacingSchedule />}
            {id == 4339 && <GreyhoundRacingSchedule />}
            {id == 2378961 && <Politics />}
            {id == 66104 && <Lottery />}

            {(id === "Esoccer" || id === "Fancybet") && (
              <div className="p-4 text-center font-bold bg-white shadow-sm">
                Data coming soon for this category.
              </div>
            )}
          </div>

          <div className="mt-4">
            <Footer />
          </div>
        </div>

        {/* --- RIGHT SIDEBAR (20%) - Only show if direct page --- */}
        {isDirectPage && (
          <div className="w-[27%] mx-[5px] h-screen sticky top-0">
            <OpenBets />
          </div>
        )}

      </div>

      {/* =========================
          MOBILE VIEW 
      ========================= */}
      <div className="grid lg:hidden grid-col-12 relative top-[56px]">
        {/* Mobile Static Banner */}
        <div
          className={`col-span-12 ${
            [7, 4339].includes(Number(id)) && "hidden"
          }`}
        >
           {/* You can use the specific sport banner here too if preferred, or keep the casino one */}
          <img
            src={getBannerImage(id)} 
            className="w-full h-[160px] object-cover"
            alt="Mobile Banner"
          />
        </div>

        {/* Mobile Highlights Header */}
        <div
          className={`col-span-12 px-[10px] py-[3px] bg-[linear-gradient(180deg,_#ffcc2e_0%,_#ffbd14_100%)] ${
            [7, 4339].includes(Number(id)) && "hidden"
          }`}
        >
          <h3 className="text-[0.75rem] text-white text-center font-bold">
            Highlights
          </h3>
        </div>

        {/* Mobile Content Area */}
        <div
          className={`col-span-12 overflow-x-auto ${
            [2, 4, 1, 2378961].includes(Number(id)) && "max-h-[260px]"
          }`}
        >
          {id == 2 && <Tennis />}
          {id == 4 && <Cricket />}
          {id == 1 && <Soccer />}
          {id == 7 && <HorseRacingSchedule />}
          {id == 4339 && <GreyhoundRacingSchedule />}
          {id == 2378961 && <Politics />}
          {id == 66104 && <Lottery />}
        </div>

        <div className="col-span-12">
            <Footer />
        </div>
      </div>
    </>
  );
}

export default AllSportHighlights;